interface ConteudoComParagrafo {
  paragrafo?: string;
}

const CARROSSEL_TEXTO_MAX = 255;

function truncarTextoCarrossel(texto: string): string {
  if (texto.length <= CARROSSEL_TEXTO_MAX) {
    return texto;
  }
  return texto.slice(0, CARROSSEL_TEXTO_MAX);
}

/**
 * Espelha a regra do backend (CarroselSisepSyncService.primeiroParagrafo):
 * usa o primeiro parágrafo preenchido entre os blocos de conteúdo.
 */
export function getCarrosselParagrafo(
  conteudos: ConteudoComParagrafo[],
  paragrafoAtual = ""
): string {
  const fromSaved = conteudos.find((c) => c.paragrafo?.trim())?.paragrafo;
  if (fromSaved) {
    return truncarTextoCarrossel(fromSaved);
  }

  return truncarTextoCarrossel(paragrafoAtual.trim());
}
